export const getNumber = (title) => {
  let number = title != null ? title.split(/-(.+)/) : [null];
  return number[0];
};
export const getTitle = (title) => {
  let number = title != null ? title.split(/-(.+)/) : [null, null];
  return number[1];
};
